var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "standard-arrow-navigation",
    class: [{
      'standard-arrow-navigation--external-header': _vm.externalHeadersVisible
    }]
  }, [_c('div', {
    staticClass: "standard-arrow-navigation-labels"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: this.displayName,
      expression: "this.displayName"
    }],
    staticClass: "standard-arrow-navigation-labels-numbers"
  }, [_vm._v("\n          " + _vm._s(_vm.currentComponentNumber) + " / " + _vm._s(_vm.visibleComponentsNumber) + "\n        ")]), _c('h2', {
    class: ['standard-arrow-navigation-labels-component-name', {
      'extra-margin': !this.displayName
    }]
  }, [_c('span', {
    attrs: {
      "id": "customs-component-navigation"
    }
  }, [_vm._v("\n            " + _vm._s(this.displayName || this.optionalDisplayName) + "\n          ")])])]), _c('div', {
    staticClass: "standard-arrow-navigation-steps"
  }, [_c('button', {
    staticClass: "standard-arrow-navigation-steps-open-prev standard-arrow-navigation-button",
    attrs: {
      "aria-label": "previous"
    },
    on: {
      "click": function click($event) {
        return _vm.changeComponent('previous');
      }
    }
  }, [_c('span', {
    staticClass: "standard-arrow-navigation-button-icon icon-arrow-left-indicator"
  })]), _c('button', {
    staticClass: "standard-arrow-navigation-steps-open-next standard-arrow-navigation-button",
    attrs: {
      "aria-label": "next"
    },
    on: {
      "click": function click($event) {
        return _vm.changeComponent();
      }
    }
  }, [_c('span', {
    staticClass: "standard-arrow-navigation-button-icon icon-arrow-right-indicator"
  })])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }